/**
 * Base class for exceptions in this module.
 */
class JetpackError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'JetpackError';
  }
}

/**
 * Exception raised for errors in the Jetpack runtime and kubernetes.
 */
export class SystemError extends JetpackError {
  constructor(message?: string) {
    super(message);
    this.name = 'SystemError';
  }
}

/**
 * Exception raised for errors from application-code that is using the SDK.
 */
export class ApplicationError extends JetpackError {
  constructor(message?: string) {
    super(message);
    this.name = 'ApplicationError';
  }
}
